// extracted by mini-css-extract-plugin
module.exports = {"container":"i_QT","label":"i_QU","buttons":"i_QV"};